<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Attention!</h1>

  <div class="expired-subscription-error-modal">
    <p class="expired-subscription-error-modal__body">
      Your subscription has expired. Please renew your subscription to continue using our services.
    </p>

    <button class="btn_primary btn_lg" (click)="onClose()">Renew</button>
  </div>
</app-base-modal>
